module.exports = __webpack_public_path__ + "static/media/IBMPlexSans-Regular.2afba28a.woff";